module.exports = __webpack_public_path__ + "images/mdj/members/resume/mobile/step2_bg_left-ee58dff803375b5d984b410b19212950.png";